import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
type Purchase = {
  name: string;
  timeAgo: string;
};
const purchases: Purchase[] = [{
  name: 'Mónica Lozano',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Carlos Fernández',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Laura Gómez',
  timeAgo: 'hace 12 minutos'
}, {
  name: 'Diego Martínez',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Valentina Ruiz',
  timeAgo: 'hace 15 minutos'
}, {
  name: 'Javier Torres',
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Camila Sánchez',
  timeAgo: 'hace 20 minutos'
}, {
  name: 'Martín Rodríguez',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'Sofía Herrera',
  timeAgo: 'hace 10 minutos'
}, {
  name: 'Nicolás Vargas',
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Florencia Díaz',
  timeAgo: 'hace 6 minutos'
}];
const VISIBLE_MS = 5000;
const HIDDEN_MS = 6000;
function initials(name: string): string {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeout: number;
    const show = () => {
      setVisible(true);
      timeout = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        show();
      }, HIDDEN_MS);
    };
    timeout = window.setTimeout(show, 3000);
    return () => window.clearTimeout(timeout);
  }, []);
  const purchase = purchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-30 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-194" data-mp="152h0j9u82oly">
      <AnimatePresence mode="wait" data-id="element-195" data-mp="1057dg0ub2p1a">
        {visible && <motion.div key={purchase.name} initial={{
        opacity: 0,
        x: -24,
        y: 8
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -24,
        y: 8
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex w-[19rem] max-w-full items-center gap-3 rounded-2xl border border-bark-800/[0.06] bg-white px-4 py-3 shadow-warm" data-id="element-196" data-mp="1f1gb4xyjsubl">
            <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage-100 font-display text-sm font-semibold text-sage-600" data-id="element-197" data-mp="1r1db6eh5ue7h">
              {initials(purchase.name)}
            </span>
            <div className="min-w-0" data-id="element-198" data-mp="24srtej38ubdh">
              <p className="truncate text-sm leading-snug text-bark-800" data-id="element-199" data-mp="24vxja0jp5ha9">
                <span className="font-semibold" data-id="element-200" data-mp="29tp98p0s6tbt">{purchase.name}</span>{' '}
                <span className="font-normal" data-id="element-201" data-mp="2er7k4kyczimg">compró</span>
              </p>
              <p className="truncate text-sm leading-snug text-bark-600" data-id="element-202" data-mp="ffoby8kvqedu">Kit Padres Presentes</p>
              <p className="mt-0.5 text-[0.7rem] font-medium text-bark-400" data-id="element-203" data-mp="kdzows6h150a">{purchase.timeAgo}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}